import React from 'react';
import { Button, colors, TableCell, TableRow } from '@insurancemenu/imenu-components-lib';
import {
  IconCheckmark,
  RadioButtonChecked,
  RadioButtonUnchecked,
} from '@insurancemenu/imenu-components-lib/dist/icons';
import { useHistory } from 'react-router-dom';
import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import { celticsRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import {
  getProductLinesFromArray,
  sortByProductLineId,
} from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { EmployerFormInstance } from 'components/web-forms-list/WebFormsTable';
import { FormStatuses } from 'types/formService';
import { createStyles } from './styles';

interface FormTableProps {
  formInstance: EmployerFormInstance;
  userRoles: SupportedUserRoles[];
  redirectLink: string;
}

const WebFormsTableRow = (props: FormTableProps): JSX.Element => {
  const classes = createStyles();
  const history = useHistory();

  const handleClick = (): void => {
    history.push(`/${props.redirectLink}/${props.formInstance.enrollmentPeriodId}/${props.formInstance.id}`);
  };
  // Buttons
  const viewButton = (
    <div>
      <Button onClick={handleClick} size="medium" type="opaque" color="primary" width="16.8rem">
        View / Edit
      </Button>
    </div>
  );

  const completeButton = (
    <div>
      <Button
        onClick={handleClick}
        size="medium"
        color="primary"
        width="16.8rem"
        className={classes.completeFormButton}
      >
        Complete Form
      </Button>
    </div>
  );

  const unavailableButton = (
    <div>
      <Button onClick={handleClick} size="medium" disabled width="16.8rem">
        Unavailable
      </Button>
    </div>
  );

  // Status labels
  const inProgressLabel = (
    <p className={classes.inProgressWrapper}>
      <RadioButtonChecked className={classes.inProgressIcon} width="2rem" color={colors.orange[600]} />
      <span>In Progress</span>
    </p>
  );

  const incompleteLabel = (
    <p className={classes.incompleteWrapper}>
      <RadioButtonUnchecked className={classes.incompletedIcon} width="2rem" />
      <span>Incomplete</span>
    </p>
  );

  const completedLabel = (
    <p className={classes.completedCardWrapper}>
      <IconCheckmark className={classes.completedIcon} width="2rem" />
      <span className={classes.cardStatusText}>Completed</span>
    </p>
  );

  const formUnavailableByRole = (): boolean => {
    if (celticsRights(props.userRoles)) {
      return false;
    }
    return (
      props.formInstance.form.roleAvailability.length > 0 &&
      !props.formInstance.form.roleAvailability.some((element) => {
        return props.userRoles.includes(element);
      })
    );
  };

  const statusButtonBar = (): JSX.Element => {
    if (formUnavailableByRole()) {
      return unavailableButton;
    }
    return props.formInstance.status === FormStatuses.COMPLETE ? viewButton : completeButton;
  };

  const statusLabel = (): JSX.Element => {
    // eslint-disable-next-line no-nested-ternary
    return props.formInstance.status === FormStatuses.COMPLETE
      ? completedLabel
      : props.formInstance.status === FormStatuses.STARTED
      ? inProgressLabel
      : incompleteLabel;
  };

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={classes.tableCell}>{props.formInstance.form.formTitle}</TableCell>
      <TableCell className={classes.tableCell}>
        {getProductLinesFromArray(props.formInstance.productLineIds.sort(sortByProductLineId))}
      </TableCell>
      <TableCell className={classes.tableCell}>{statusLabel()}</TableCell>
      <TableCell className={classes.tableCell}>{statusButtonBar()}</TableCell>
    </TableRow>
  );
};

export default WebFormsTableRow;
